var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8307 20.3125C44.9766 20.3125 44.2682 19.6042 44.2682 18.75V14.5834C44.2682 9.20835 40.7891 5.72919 35.4141 5.72919H14.5807C9.20573 5.72919 5.72656 9.20835 5.72656 14.5834V18.75C5.72656 19.6042 5.01823 20.3125 4.16406 20.3125C3.3099 20.3125 2.60156 19.6042 2.60156 18.75V14.5834C2.60156 7.41669 7.41406 2.60419 14.5807 2.60419H35.4141C42.5807 2.60419 47.3932 7.41669 47.3932 14.5834V18.75C47.3932 19.6042 46.6849 20.3125 45.8307 20.3125Z",
    fill: "#1D9CFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4141 47.3958H14.5807C7.41406 47.3958 2.60156 42.5833 2.60156 35.4167V31.25C2.60156 30.3958 3.3099 29.6875 4.16406 29.6875C5.01823 29.6875 5.72656 30.3958 5.72656 31.25V35.4167C5.72656 40.7917 9.20573 44.2708 14.5807 44.2708H35.4141C40.7891 44.2708 44.2682 40.7917 44.2682 35.4167V31.25C44.2682 30.3958 44.9766 29.6875 45.8307 29.6875C46.6849 29.6875 47.3932 30.3958 47.3932 31.25V35.4167C47.3932 42.5833 42.5807 47.3958 35.4141 47.3958Z",
    fill: "#1D9CFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8307 26.5625H4.16406C3.3099 26.5625 2.60156 25.8542 2.60156 25C2.60156 24.1458 3.3099 23.4375 4.16406 23.4375H45.8307C46.6849 23.4375 47.3932 24.1458 47.3932 25C47.3932 25.8542 46.6849 26.5625 45.8307 26.5625Z",
    fill: "#1D9CFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3776 18.75H15.6276C15.0443 18.75 14.5859 18.2917 14.5859 17.7084V13.5417C14.5859 11.8125 15.9818 10.4167 17.7109 10.4167H32.2943C34.0234 10.4167 35.4193 11.8125 35.4193 13.5417V17.7084C35.4193 18.2917 34.9609 18.75 34.3776 18.75Z",
    fill: "#1D9CFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3776 31.25H15.6276C15.0443 31.25 14.5859 31.7083 14.5859 32.2917V36.4583C14.5859 38.1875 15.9818 39.5833 17.7109 39.5833H32.2943C34.0026 39.5833 35.4193 38.1875 35.4193 36.4583V32.2917C35.4193 31.7083 34.9609 31.25 34.3776 31.25Z",
    fill: "#1D9CFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketTotal);
export default __webpack_public_path__ + "static/media/ticket-total.3a1196673372bc797751091b45ccd6f6.svg";
export { ForwardRef as ReactComponent };